import {useEffect, useCallback} from 'react'
import {useDispatch} from 'redux-react-hook'
import ApiSdk from 'services/callApi'
import {
  orders as ordersAction,
  transactionHistoryLoadedAll as transactionHistoryLoadedAllAction
} from 'actions'
import useTransactionHistory from './useTransactionHistory'

const LIMIT = 10
let curPage = 1

function useTransactionHistoryDataProvider (isLogin, asset, start, end, isFocus) {
  const dispatch = useDispatch()
  const {data: loadedTransactionHistories, hasMore} = useTransactionHistory()

  const fetchData = useCallback(
    async () => {
      if (!isLogin) return
      const {transactionHistories} = await ApiSdk.futures.getTransactionHistory(
        {
          asset,
          startTime: start,
          endTime: end,
          page: curPage,
        },
        true
      )

      if (transactionHistories) {
        if (Object.keys(transactionHistories).length < LIMIT) {
          dispatch(transactionHistoryLoadedAllAction())
        } else {
          dispatch(transactionHistoryLoadedAllAction(true))
        }
        dispatch(ordersAction({transactionHistories}))

      } else {
        dispatch(transactionHistoryLoadedAllAction())
      }
    },
    [isLogin, asset, start, end, dispatch]
  )

  const loadMore = useCallback(() => {
    if (!hasMore) return Promise.resolve()
    curPage++
    return fetchData()
  }, [fetchData, hasMore])

  useEffect(() => {
    if (isFocus) {
      curPage = 1
      dispatch(ordersAction({transactionHistories: {}}))
      fetchData()
    }
  }, [dispatch, fetchData, isFocus])

  return {
    data: loadedTransactionHistories,
    fetchData,
    loadMore,
    hasMore
  }
}

export default useTransactionHistoryDataProvider
